/* eslint-disable consistent-return */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable max-len */
import React, { useState } from 'react';

export default function ThreePlModal({
    setThreePlPopup, ThreelPl, handleUpdate3pl, GroupCategory, ThreePlPopup, threeplSelected, ItemLevel3pl, setItemLevel3pl,
}) {
    const selectedValue = ItemLevel3pl && Object.keys(ItemLevel3pl).length > 0 ? ItemLevel3pl['3pl'] : threeplSelected;
    const [selected, setselected] = useState(selectedValue);
    const handleSave = () => {
        const payload = {
            category: GroupCategory,
            item_id: ThreePlPopup === 'global' ? undefined : ThreePlPopup,
            default: ThreePlPopup === 'global',
            '3pl': selected,
        };
        handleUpdate3pl(payload, 'threepl', 'threepl');
    };
    const [searchKey, setsearchKey] = useState('');
    const handleSearch = (val) => {
        if (searchKey === '') {
            return val;
        }
        if (val.DESCRIPTION?.toLowerCase().includes(searchKey.toLowerCase())
        || val.POSTAL_CODE?.toLowerCase().includes(searchKey.toLowerCase())
        || val.STATE?.toLowerCase().includes(searchKey.toLowerCase())) {
            return val;
        }
    };
    return (
        <div className="modal-dialog modal-dialog-centered relative min-w-[496px] pointer-events-none">
            <div className="modal-content border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
                <div className="modal-header flex flex-shrink-0 items-center justify-center pt-5 rounded-t-md relative">
                    <h5 className="text-lg font-semibold text-[#090406]" id="exampleModalScrollableLabel">
                        Change 3PL
                    </h5>
                    <button
                        onClick={() => {
                            setItemLevel3pl({});
                            setThreePlPopup('');
                        }}
                        type="button"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                        className="absolute top-[22px] right-[18px]"
                    >
                        <img src="/images/Component1587.svg" alt="icon" className="w-3 h-3" />
                    </button>
                </div>
                <div className="modal-body relative py-[18px] pl-10 px-[23px]">
                    <div className="flex items-center w-full search relative">
                        <div className="relative w-full">
                            <input onChange={(e) => setsearchKey(e.target.value)} type="text" id="search" className="px-3.5 h-[35px] w-full rounded-lg outline-0 border border-[#B1B4B7] bg-[#FFFFFF] sm:text-lg text-base font-normal text-[#090406]" placeholder="Search" autoComplete="off" />
                            <label htmlFor="search" />
                        </div>
                        <img src="/images/search.svg" alt="icon" className="absolute top-[12px] right-3.5" />
                    </div>
                    <div className="rounded-lg bg-[#F5F5FA] p-4 mt-3.5 h-[438px] overflow-auto dropdown-menu">
                        {ThreelPl.length > 0 && ThreelPl.filter((item) => handleSearch(item)).map((val) => (
                            <div key={val} className="relative checkbox1 mb-3 flex">
                                <input type="radio" id={val.DESCRIPTION} className="cursor-pointer" onChange={() => setselected(val)} checked={selected.DESCRIPTION === val.DESCRIPTION} />
                                <label htmlFor={val.DESCRIPTION} className="flex">
                                    <span className="text-lg font-normal text-[#555259] pl-8 relative cursor-pointer">
                                        {val.DESCRIPTION}
                                    </span>
                                </label>
                            </div>
                        ))}
                    </div>
                    <div className="flex justify-center mt-2 mb-4">
                        <button onClick={() => handleSave()} type="button" className="h-[42px] w-[168px] rounded-lg bg-[#555259] py-3 text-xs6 font-semibold text-[#FFFFFF] 3pl inline-block" data-bs-dismiss="modal" aria-label="Close">
                            Change
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
